import moment from "moment-timezone";
import { LessonSession, LessonSessionStatus } from "./model";
import { getInstructorBillingType, InstructorBillingType } from "./status";

type SessionInvoice = { lesson_session_salary?: number | null } | null | undefined;
type BillingSession = { status?: string | null } | null | undefined;

export function getSessionPrice(
  session: BillingSession,
  salary: number,
  invoice?: SessionInvoice
) {
  return getInstructorBillingType(session) === InstructorBillingType.NOT_PAID
    ? 0
    : invoice && invoice.lesson_session_salary
      ? invoice.lesson_session_salary
      : salary;
}

type NamedEntity = { name?: string | null };
type SessionNameSource = NamedEntity & { plan?: NamedEntity | null };

export function getSessionOrPlanName(session: SessionNameSource | null | undefined) {
  if (session) {
    if (session.name) {
      return session.name;
    } else if (session.plan) {
      return session.plan.name;
    }
  }
  return "Unnamed lesson";
}

type SessionEditableFields = {
  name?: string | null;
  description?: string | null;
  scheduled?: string;
};

type SessionChangeComparable = SessionEditableFields & {
  instructor_id?: string;
};

type SessionChangeSource = SessionEditableFields & {
  instructor?: {
    id: string;
  };
};

export function isSessionChanged(
  newSession: SessionChangeComparable,
  oldSession: SessionChangeSource
) {
  return (
    (newSession.name && newSession.name !== oldSession.name) ||
    (newSession.description && newSession.description !== oldSession.description) ||
    (newSession.instructor_id && newSession.instructor_id !== oldSession.instructor?.id)
  );
}

export function isAssessmentSession(session?: LessonSession | null) {
  return !!session && session.type === "assessment-session";
}

export const CHAT_MAX_SIZE_REACHED_ERROR = "Chat growing too large";

// Payments/invoice month views only include billable outcome statuses and expect newest-first order.
type FilteredSession = {
  status: LessonSessionStatus;
  scheduled: string;
};
export function getInvoiceEligibleSessions<T extends FilteredSession>(
  sessions: T[]
): T[] {
  const possibleStatuses: LessonSessionStatus[] = [
    "completed",
    "instructor-canceled",
    "student-canceled",
    "instructor-missed",
    "student-missed",
    "issues-rescheduled",
  ];

  return sessions
    .filter(session => possibleStatuses.includes(session.status))
    .sort(
      (first, second) =>
        moment.utc(second.scheduled).toDate().getTime() -
        moment.utc(first.scheduled).toDate().getTime()
    );
}
export const LESSON_SESSION_OBJ = {
  name: {
    label: "Name",
    required: false,
    maxLength: 128,
  },
  missed_reason: {
    label: "Missed/Rescheduled Session Reason",
    required: false,
    maxLength: 1024,
  },
} as const;
